const STORAGE_PREFIX = "softcar.productTour.completed:";

export const getTourStorageKey = (userId) => `${STORAGE_PREFIX}${userId}`;

export const isTourCompleted = (userId) => {
    if (!userId) {
        return false;
    }

    try {
        return localStorage.getItem(getTourStorageKey(userId)) === "true";
    } catch (_error) {
        return false;
    }
};

export const markTourCompleted = (userId) => {
    if (!userId) {
        return;
    }

    try {
        localStorage.setItem(getTourStorageKey(userId), "true");
    } catch (_error) {
        // Ignore quota / private-mode failures
    }
};
